// Values are translation keys (src/assets/i18n/*.json) — render them with the translate pipe / TranslateService.
export const ErrorMessages = {
  personalInformation: {
    invalidFirstName: 'errorMessages.personalInformation.invalidFirstName',
    minlengthFirstName: 'errorMessages.personalInformation.minlengthFirstName',
    maxLengthFirstName: 'errorMessages.personalInformation.maxLengthFirstName',
    requiredFirstName: 'errorMessages.personalInformation.requiredFirstName',
    invalidFirstNameArabic: 'errorMessages.personalInformation.invalidFirstNameArabic',
    minlengthFirstNameArabic: 'errorMessages.personalInformation.minlengthFirstNameArabic',
    maxLengthFirstNameArabic: 'errorMessages.personalInformation.maxLengthFirstNameArabic',
    requiredFirstNameArabic: 'errorMessages.personalInformation.requiredFirstNameArabic',
    invalidLastName: 'errorMessages.personalInformation.invalidLastName',
    minlengthLastName: 'errorMessages.personalInformation.minlengthLastName',
    maxLengthLastName: 'errorMessages.personalInformation.maxLengthLastName',
    requiredLastName: 'errorMessages.personalInformation.requiredLastName',
    invalidLastNameArabic: 'errorMessages.personalInformation.invalidLastNameArabic',
    minlengthLastNameArabic: 'errorMessages.personalInformation.minlengthLastNameArabic',
    maxLengthLastNameArabic: 'errorMessages.personalInformation.maxLengthLastNameArabic',
    requiredLastNameArabic: 'errorMessages.personalInformation.requiredLastNameArabic',
    requiredBirthDate: 'errorMessages.personalInformation.requiredBirthDate',
    requiredGender: 'errorMessages.personalInformation.requiredGender',
    requiredEmployeeNumber: 'errorMessages.personalInformation.requiredEmployeeNumber',
    maxLengthEmployeeNumber: 'errorMessages.personalInformation.maxLengthEmployeeNumber',
    minLengthEmployeeNumber: 'errorMessages.personalInformation.minLengthEmployeeNumber',
    invalidEmployeeNumber: 'errorMessages.personalInformation.invalidEmployeeNumber',
    requiredCin: 'errorMessages.personalInformation.requiredCin',
    maxLengthCin: 'errorMessages.personalInformation.maxLengthCin',
    minLengthCin: 'errorMessages.personalInformation.minLengthCin',
    invalidCin: 'errorMessages.personalInformation.invalidCin',
    invalidPassportNumber: 'errorMessages.personalInformation.invalidPassportNumber',
    maxLengthPassportNumber: 'errorMessages.personalInformation.maxLengthPassportNumber',
    maxLengthEmail: 'errorMessages.personalInformation.maxLengthEmail',
    minLengthEmail: 'errorMessages.personalInformation.minLengthEmail',
    invalidEmail: 'errorMessages.personalInformation.invalidEmail',
    maxLengthActiveDirectoryUsername: 'errorMessages.personalInformation.maxLengthActiveDirectoryUsername',
    minLengthActiveDirectoryUsername: 'errorMessages.personalInformation.minLengthActiveDirectoryUsername',
    invalidPersonalEmail: 'errorMessages.personalInformation.invalidPersonalEmail',
    invalidCorporateEmail: 'errorMessages.personalInformation.invalidCorporateEmail',
    invalidPhoneNumber: 'errorMessages.personalInformation.invalidPhoneNumber',
    invalidEmergencyPhone: 'errorMessages.personalInformation.invalidEmergencyPhone',
  },
  civilStateDetails: {
    maxLengthCin: 'errorMessages.civilStateDetails.maxLengthCin',
    minLengthCin: 'errorMessages.civilStateDetails.minLengthCin',
    invalidCin: 'errorMessages.civilStateDetails.invalidCin',
    invalidPassportNumber: 'errorMessages.civilStateDetails.invalidPassportNumber',
    maxLengthPassportNumber: 'errorMessages.civilStateDetails.maxLengthPassportNumber',
    maxLengthDependentName: 'errorMessages.civilStateDetails.maxLengthDependentName',
    minLengthDependentName: 'errorMessages.civilStateDetails.minLengthDependentName',
    invalidDependentName: 'errorMessages.civilStateDetails.invalidDependentName',
    requiredDependentName: 'errorMessages.civilStateDetails.requiredDependentName',
    requiredDependentType: 'errorMessages.civilStateDetails.requiredDependentType',
    requiredDependentDate: 'errorMessages.civilStateDetails.requiredDependentDate',
  },
  locationDetails: {
    required: 'employeesManagement.employeesDetails.locationDetails.required',
    requiredAddressType: 'employeesManagement.employeesDetails.locationDetails.requiredAddressType',
    requiredCountry: 'employeesManagement.employeesDetails.locationDetails.requiredCountry',
    requiredCity: 'employeesManagement.employeesDetails.locationDetails.requiredCity',
    requiredAddress: 'employeesManagement.employeesDetails.locationDetails.requiredAddress',
    requiredRegion: 'employeesManagement.employeesDetails.locationDetails.requiredRegion',
    maxLengthAddress: 'employeesManagement.employeesDetails.locationDetails.maxLengthAddress',
    minLengthAddress: 'employeesManagement.employeesDetails.locationDetails.minLengthAddress',
    invalidAddress: 'employeesManagement.employeesDetails.locationDetails.invalidAddress',
    maxLengthCity: 'employeesManagement.employeesDetails.locationDetails.maxLengthCity',
    minLengthCity: 'employeesManagement.employeesDetails.locationDetails.minLengthCity',
    invalidCity: 'employeesManagement.employeesDetails.locationDetails.invalidCity',
    maxLengthCodePostal: 'employeesManagement.employeesDetails.locationDetails.maxLengthCodePostal',
    minLengthCodePostal: 'employeesManagement.employeesDetails.locationDetails.minLengthCodePostal',
    invalidCodePostal: 'employeesManagement.employeesDetails.locationDetails.invalidCodePostal',
    maxLengthRegion: 'employeesManagement.employeesDetails.locationDetails.maxLengthRegion',
    minLengthRegion: 'employeesManagement.employeesDetails.locationDetails.minLengthRegion',
    invalidRegion: 'employeesManagement.employeesDetails.locationDetails.invalidRegion',
  },
  socialSecurityDetails: {
    maxLengthMedicalInsurance: 'errorMessages.socialSecurityDetails.maxLengthMedicalInsurance',
    minLengthMedicalInsurance: 'errorMessages.socialSecurityDetails.minLengthMedicalInsurance',
    invalidMedicalInsurance: 'errorMessages.socialSecurityDetails.invalidMedicalInsurance',
    maxLengthSocialSecurity: 'errorMessages.socialSecurityDetails.maxLengthSocialSecurity',
    minLengthSocialSecurity: 'errorMessages.socialSecurityDetails.minLengthSocialSecurity',
    invalidSocialSecurity: 'errorMessages.socialSecurityDetails.invalidSocialSecurity',
    maxLengthSecondaryPension: 'errorMessages.socialSecurityDetails.maxLengthSecondaryPension',
    minLengthSecondaryPension: 'errorMessages.socialSecurityDetails.minLengthSecondaryPension',
    invalidSecondaryPension: 'errorMessages.socialSecurityDetails.invalidSecondaryPension',
  },
  contractDetails: {
    requiredType: 'errorMessages.contractDetails.requiredType',
    requiredEmploymentDate: 'errorMessages.contractDetails.requiredEmploymentDate',
    requiredRole: 'errorMessages.contractDetails.requiredRole',
    requiredDate: 'errorMessages.contractDetails.requiredDate',
    requiredEndDate: 'errorMessages.contractDetails.requiredEndDate',
    maxLengthDescription: 'errorMessages.contractDetails.maxLengthDescription',
    invalidDescription: 'errorMessages.contractDetails.invalidDescription',
    outOfRangeEndDate: 'errorMessages.contractDetails.outOfRangeEndDate',
    outOfRangeStartDate: 'errorMessages.contractDetails.outOfRangeStartDate',
  },
  visitMedicals: {
    requiredCenter: 'errorMessages.visitMedicals.requiredCenter',
    requiredVisitDate: 'errorMessages.visitMedicals.requiredVisitDate',
    maxLengthRemarque: 'errorMessages.visitMedicals.maxLengthRemarque',
    invalidRemarque: 'errorMessages.visitMedicals.invalidRemarque',
  },
  careerDetails: {
    invalidSeniorServiceLeaderName: 'errorMessages.careerDetails.invalidSeniorServiceLeaderName',
    invalidServiceLeaderName: 'errorMessages.careerDetails.invalidServiceLeaderName',
    invalidManagerName: 'errorMessages.careerDetails.invalidManagerName',
    invalidExperience: 'errorMessages.careerDetails.invalidExperience',
    invalidTechnologies: 'errorMessages.careerDetails.invalidTechnologies',
    maxexperienceMonths: 'errorMessages.careerDetails.maxexperienceMonths',
    maxexperienceYears: 'errorMessages.careerDetails.maxexperienceYears',
  },
  education: {
    requiredDegreeName: 'errorMessages.education.requiredDegreeName',
    maxLengthDegreeName: 'errorMessages.education.maxLengthDegreeName',
    minLengthDegreeName: 'errorMessages.education.minLengthDegreeName',
    invalidDegreeName: 'errorMessages.education.invalidDegreeName',
    requiredDegree: 'errorMessages.education.requiredDegree',
    requiredLevel: 'errorMessages.education.requiredLevel',
    requiredStartDate: 'errorMessages.education.requiredStartDate',
    requiredEndDate: 'errorMessages.education.requiredEndDate',
    invalidStartEnd: 'errorMessages.education.invalidStartEnd',
    requiredYears: 'errorMessages.education.requiredYears',
    invalidYears: 'errorMessages.education.invalidYears',
  },
  languages: {
    requiredLanguageName: 'errorMessages.languages.requiredLanguageName',
    requiredLanguageLevel: 'errorMessages.languages.requiredLanguageLevel',
  },
  financialDetails: {
    requiredAccountingId: 'errorMessages.financialDetails.requiredAccountingId',
    invalidAccountingId: 'errorMessages.financialDetails.invalidAccountingId',
    maxLengthAccountingId: 'errorMessages.financialDetails.maxLengthAccountingId',
    requiredBankName: 'errorMessages.financialDetails.requiredBankName',
    maxLengthBankName: 'errorMessages.financialDetails.maxLengthBankName',
    minLengthBankName: 'errorMessages.financialDetails.minLengthBankName',
    invalidBankName: 'errorMessages.financialDetails.invalidBankName',
    requiredRib: 'errorMessages.financialDetails.requiredRib',
    maxLengthRib: 'errorMessages.financialDetails.maxLengthRib',
    minLengthRib: 'errorMessages.financialDetails.minLengthRib',
    invalidRib: 'errorMessages.financialDetails.invalidRib',
    invalidSalary: 'errorMessages.financialDetails.invalidSalary',
    minLengthSalary: 'errorMessages.financialDetails.minLengthSalary',
    outOfRangeStartDate: 'errorMessages.financialDetails.outOfRangeStartDate',
    outOfRangeContractEndDate: 'errorMessages.financialDetails.outOfRangeContractEndDate',
    overlappingEndDate: 'errorMessages.financialDetails.overlappingEndDate',
    overlappingStartDate: 'errorMessages.financialDetails.overlappingStartDate',
  },
  informationTechnology: {
    required: 'errorMessages.informationTechnology.required',
    maxLength: 'errorMessages.informationTechnology.maxLength',
    minLength: 'errorMessages.informationTechnology.minLength',
    invalidComputerId: 'errorMessages.informationTechnology.invalidComputerId',
  },
  client: {
    requiredName: 'errorMessages.client.requiredName',
    requiredOffshoreLevel: 'errorMessages.client.requiredOffshoreLevel',
    requiredCountry: 'errorMessages.client.requiredCountry',
    requiredSector: 'errorMessages.client.requiredSector',
    requiredNearShoreOffice: 'errorMessages.client.requiredNearShoreOffice',
    requiredCluster: 'errorMessages.client.requiredCluster',
    requiredIsInternational: 'errorMessages.client.requiredIsInternational',
    requiredStartDate: 'errorMessages.client.requiredStartDate',
    requiredCurrency: 'errorMessages.client.requiredCurrency',
    requiredInvoicingName: 'errorMessages.client.requiredInvoicingName',
    invalidChars: 'errorMessages.client.invalidChars',
    invalidOrder: 'errorMessages.client.invalidOrder',
    minLengthName: 'errorMessages.client.minLengthName',
    maxLengthName: 'errorMessages.client.maxLengthName',
    maxLengthDescription: 'errorMessages.client.maxLengthDescription',
    outOfRangeStartDate: 'errorMessages.client.outOfRangeStartDate',
    outOfRangeEndDate: 'errorMessages.client.outOfRangeEndDate',
  },
  clientManagementAssignment: {
    requiredEmployee: 'errorMessages.clientManagementAssignment.requiredEmployee',
    requiredClient: 'errorMessages.clientManagementAssignment.requiredClient',
    requiredStartDate: 'errorMessages.clientManagementAssignment.requiredStartDate',
    minHourlyRate: 'errorMessages.clientManagementAssignment.minHourlyRate',
    minAssignmentPercentage: 'errorMessages.clientManagementAssignment.minAssignmentPercentage',
    outOfRangeStartDate: 'errorMessages.clientManagementAssignment.outOfRangeStartDate',
    outOfRangeAssignmentEndDate: 'errorMessages.clientManagementAssignment.outOfRangeAssignmentEndDate',
  },
  project: {
    requiredName: 'errorMessages.project.requiredName',
    requiredClient: 'errorMessages.project.requiredClient',
    requiredStartDate: 'errorMessages.project.requiredStartDate',
    requiredInvoiceable: 'errorMessages.project.requiredInvoiceable',
    requiredCurrency: 'errorMessages.project.requiredCurrency',
    requiredInvoicingName: 'errorMessages.project.requiredInvoicingName',
    invalidNameStartWithNumber: 'errorMessages.project.invalidNameStartWithNumber',
    minLengthName: 'errorMessages.project.minLengthName',
    maxLengthName: 'errorMessages.project.maxLengthName',
    maxLengthInvoicingName: 'errorMessages.project.maxLengthInvoicingName',
    maxLengthDescription: 'errorMessages.project.maxLengthDescription',
    outOfRangeEndDate: 'errorMessages.project.outOfRangeEndDate',
    outOfRangeClientStartDate: 'errorMessages.project.outOfRangeClientStartDate',
    outOfRangeClientEndDate: 'errorMessages.project.outOfRangeClientEndDate',
  },
  staffingRecord: {
    requiredEmployee: 'errorMessages.staffingRecord.requiredEmployee',
    requiredClient: 'errorMessages.staffingRecord.requiredClient',
    requiredProject: 'errorMessages.staffingRecord.requiredProject',
    requiredStartDate: 'errorMessages.staffingRecord.requiredStartDate',
    requiredHourlyRate: 'errorMessages.staffingRecord.requiredHourlyRate',
    requiredAssignmentPercentage: 'errorMessages.staffingRecord.requiredAssignmentPercentage',
    minHourlyRate: 'errorMessages.staffingRecord.minHourlyRate',
    minAssignmentPercentage: 'errorMessages.staffingRecord.minAssignmentPercentage',
    outOfRangeStartDate: 'errorMessages.staffingRecord.outOfRangeStartDate',
    outOfRangeAssignmentEndDate: 'errorMessages.staffingRecord.outOfRangeAssignmentEndDate',
    beforeEmploymentDateStartDate: 'errorMessages.staffingRecord.beforeEmploymentDateStartDate',
  },
  runtimeSettings: {
    maxLengthAccountNumberLabel: 'layout.configurations.runtimeSettings.errors.maxLengthAccountNumberLabel',
    minLengthAccountNumberLabel: 'layout.configurations.runtimeSettings.errors.minLengthAccountNumberLabel',
    invalidAccountNumberLabel: 'layout.configurations.runtimeSettings.errors.invalidAccountNumberLabel',
    invalidSocialSecurityProviderName: 'layout.configurations.runtimeSettings.errors.invalidSocialSecurityProviderName',
    minLengthSocialSecurityProviderName: 'layout.configurations.runtimeSettings.errors.minLengthSocialSecurityProviderName',
    maxLengthSocialSecurityProviderName: 'layout.configurations.runtimeSettings.errors.maxLengthSocialSecurityProviderName',
    invalidSecondaryPensionProvider: 'layout.configurations.runtimeSettings.errors.invalidSecondaryPensionProvider',
    minLengthSecondaryPensionProvider: 'layout.configurations.runtimeSettings.errors.minLengthSecondaryPensionProvider',
    maxLengthSecondaryPensionProvider: 'layout.configurations.runtimeSettings.errors.maxLengthSecondaryPensionProvider',
    invalidMedicalInsuranceProvider: 'layout.configurations.runtimeSettings.errors.invalidMedicalInsuranceProvider',
    minLengthMedicalInsuranceProvider: 'layout.configurations.runtimeSettings.errors.minLengthMedicalInsuranceProvider',
    maxLengthMedicalInsuranceProvider: 'layout.configurations.runtimeSettings.errors.maxLengthMedicalInsuranceProvider',
    invalidAcademicalDegrees: 'layout.configurations.runtimeSettings.errors.invalidAcademicalDegrees',
    minLengthAcademicalDegrees: 'layout.configurations.runtimeSettings.errors.minLengthAcademicalDegrees',
    maxLengthAcademicalDegrees: 'layout.configurations.runtimeSettings.errors.maxLengthAcademicalDegrees',
    invalidHighSchoolDiplomaName: 'layout.configurations.runtimeSettings.errors.invalidHighSchoolDiplomaName',
    minLengthHighSchoolDiplomaName: 'layout.configurations.runtimeSettings.errors.minLengthHighSchoolDiplomaName',
    maxLengthHighSchoolDiplomaName: 'layout.configurations.runtimeSettings.errors.maxLengthHighSchoolDiplomaName',
    invalidContractDescription: 'layout.configurations.runtimeSettings.errors.invalidContractDescription',
    minLengthContractDescription: 'layout.configurations.runtimeSettings.errors.minLengthContractDescription',
    maxLengthContractDescription: 'layout.configurations.runtimeSettings.errors.maxLengthContractDescription',
    invalidAppType: 'layout.configurations.runtimeSettings.errors.invalidAppType',
    minLengthAppType: 'layout.configurations.runtimeSettings.errors.minLengthAppType',
    maxLengthAppType: 'layout.configurations.runtimeSettings.errors.maxLengthAppType',
    minLengthAccountNumberPattern: 'layout.configurations.runtimeSettings.errors.minLengthAccountNumberPattern',
    maxLengthAccountNumberPattern: 'layout.configurations.runtimeSettings.errors.maxLengthAccountNumberPattern',
    invalidLastPromotionPeriod: 'layout.configurations.runtimeSettings.errors.invalidLastPromotionPeriod',
    maxLengthLastPromotionPeriod: 'layout.configurations.runtimeSettings.errors.maxLengthLastPromotionPeriod',
    invalidProbationPeriodMonths: 'layout.configurations.runtimeSettings.errors.invalidProbationPeriodMonths',
    maxLengthProbationPeriodMonths: 'layout.configurations.runtimeSettings.errors.maxLengthProbationPeriodMonths',
  },
  staffedRole: {
    requiredRole: 'configurations.roles.errorMessages.roleR',
    invalidRole: 'configurations.roles.errorMessages.roleI',
    requiredRate: 'configurations.roles.errorMessages.rateRequired',
    minRate: 'configurations.roles.errorMessages.rateMin',
  },
  poolActivity: {
    requiredActivity: 'poolManagement.activities.addActivity.errorMeassage.requiredActivity',
    requiredResponsible: 'poolManagement.activities.addActivity.errorMeassage.requiredResponsible',
    requiredTechnologies: 'poolManagement.activities.addActivity.errorMeassage.requiredTechnologies',
    requiredStartDate: 'poolManagement.activities.addActivity.errorMeassage.requiredStartDate',
    requiredDescription: 'poolManagement.activities.addActivity.errorMeassage.requiredDescription',
    outOfRangeEndDate: 'errorMessages.poolActivity.outOfRangeEndDate',
    outOfRangeStartDate: 'errorMessages.poolActivity.outOfRangeStartDate',
  },
};
